export default {
  OPEN_MODAL: '@SAMORA_OPEN_MODAL',
  CLOSE_MODAL: '@SAMORA_CLOSE_MODAL',

  MODAL_OPENED: '@SAMORA_MODAL_OPENED',
  MODAL_CLOSED: '@SAMORA_MODAL_CLOSED',

  OPEN_SIDEBAR: '@SAMORA_OPEN_SIDEBAR',
  CLOSE_SIDEBAR: '@SAMORA_CLOSE_SIDEBAR',
};
